// 9fbef606107a605d69c0edbcd8029e5d
import CONSTANT from '../AIAssistant.constants';

export const fetchResponse = (payload = {}) => {
  return {
    type: CONSTANT.FETCH_RESPONSE,
    payload,
  };
};

export const setChatSummaryQ = payload => {
  return {
    type: CONSTANT.SET_CHAT_SUMMARY_Q,
    payload,
  };
};

export const setChatSummaryR = payload => {
  return {
    type: CONSTANT.SET_CHAT_SUMMARY_R,
    payload,
  };
};
export const setLoadingState = payload => {
  return {
    type: CONSTANT.SET_LOADING,
    payload,
  };
};
export const setError = payload => {
  return {
    type: CONSTANT.SET_ERROR_INFO,
    payload,
  };
};

